import React from 'react';
import { Box, Typography } from '@mui/material';
import { resolveSlotValues, getDTWidgetSlots } from '../../registry/dtWidgetTypes';
import { useDTDemoMap } from '../../hooks/useDTDemoTick';
import { hasLiveSlotValue } from '../../utils/dtDemoFallback';
import { dtWidgetFilledColumnSx } from '../../styles/dtWidgetStyleTokens';

const DEFAULT_SLOTS = getDTWidgetSlots('dt-vfd-status');
const PARAM_SLOT_KEYS = ['motorVoltage', 'dcLinkVoltage', 'current', 'power', 'frequency', 'powerFactor'];

function DTVFDStatus({ widget, data, theme }) {
  const isDark = theme === 'dark';
  const tagprops = widget?.props?.extended?.tagprops || [];
  const liveData = Array.isArray(data) ? data : [];
  const slotValues = resolveSlotValues(tagprops, liveData);
  const demoMap = useDTDemoMap('dt-vfd-status');

  const statusResolved = slotValues['vfdStatus'];
  const statusRaw = hasLiveSlotValue(statusResolved) ? statusResolved.value : demoMap.vfdStatus;
  const statusNum = parseFloat(statusRaw);
  const statusLabel = statusNum === 2 ? 'TRP' : statusNum === 1 ? 'ON' : 'OFF';
  const statusColor = statusNum === 1 ? 'green' : 'red';
  const statusAlias = statusResolved?.alias || 'VFD Status';

  const paramSlots = DEFAULT_SLOTS.filter((s) => PARAM_SLOT_KEYS.includes(s.key));

  return (
    <Box sx={{ ...dtWidgetFilledColumnSx, px: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.75, flexShrink: 0 }}>
        <Typography variant="subtitle2" sx={{ color: isDark ? '#fff' : '#000', fontWeight: 700 }}>{statusAlias}</Typography>
        <Box sx={{ px: 1.5, py: 0.5, borderRadius: 5, backgroundColor: statusColor, color: '#fff', fontWeight: 700, fontSize: 12 }}>
          {statusLabel}
        </Box>
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', overflow: 'hidden' }}>
        {paramSlots.map((slot) => {
          const resolved = slotValues[slot.key];
          const liveOk = hasLiveSlotValue(resolved);
          const displayVal = liveOk ? resolved.value : demoMap[slot.key] ?? '—';
          const unit = resolved?.unit || slot.unit;
          return (
            <Box key={slot.key} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: '1 1 0', minHeight: 0, borderBottom: `1px solid ${isDark ? '#333' : '#eee'}`, py: 0.25 }}>
              <Typography variant="caption" sx={{ color: isDark ? '#aaa' : '#555', fontWeight: 600 }}>
                {resolved?.alias || slot.label}
              </Typography>
              <Typography variant="caption" sx={{ color: isDark ? '#fff' : '#000' }}>
                {displayVal}{unit ? ` ${unit}` : ''}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default React.memo(DTVFDStatus);
